module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAIAAABL1vtsAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIhJREFUeNpiFBUVZaAMMDFQDFiQOS0tLTo6OsRoCwgIwO4KoH5tbW38mmVlZa2srHC6AgiuXr2KbAMmKAUDKofFqBGjRtAjm0GyAFr6RQPW1tYEjPj48eOxY8coymafPn06evQoHiPQ9NMmLIDlxYYNG/B7BJ8RV65cIWjnYzBAFmGkvPgFCDAA8zclCDSIcOcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/plano/images/icons/icon_view.png
// module id = 2607
// module chunks = 0